/**
 * Shared scroll reveal.
 *
 * Contract: the markup ships visible. This script may only ever ADD the hidden
 * state, and only to elements currently below the fold. Two consequences:
 *   - JS off, blocked, or erroring leaves every section readable.
 *   - Above-fold content is never hidden, so there is no flash of blank band
 *     while the observer spins up.
 */
(function () {
  if (window.rootsRevealReady) return;
  window.rootsRevealReady = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.remove('roots-reveal--pending');
        entry.target.classList.add('roots-reveal--in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -6% 0px' }
  );

  function arm(root) {
    (root || document).querySelectorAll('.roots-reveal').forEach(function (el) {
      if (el.classList.contains('roots-reveal--in') || el.classList.contains('roots-reveal--pending')) return;
      // Already on screen: leave it alone. Hiding it now would be a visible flash.
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('roots-reveal--pending');
      observer.observe(el);
    });
  }

  arm();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
  // Symmetric with the load handler. Without this, a section deleted or re-rendered
  // in the Theme Editor before it ever intersects stays in the observer's target set.
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.roots-reveal').forEach(function (el) { observer.unobserve(el); });
  });
})();
